import { render, staticRenderFns } from "./BasicTelInput.vue?vue&type=template&id=f55dd144&"
import script from "./BasicTelInput.vue?vue&type=script&lang=js&"
export * from "./BasicTelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports